import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './HelpButton.css';
import { CommandManualModal } from '../CommandManualModal/CommandManualModal';

export const HelpButton: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleHideModal = () => setShowModal(false);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && showModal) {
        e.preventDefault();
        handleHideModal();
      }
    };

    if (showModal) {
      window.addEventListener('keydown', handleKeyPress);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [showModal]);

  return (
    <>
      <Button
        variant="info"
        size="lg"
        className="help-button"
        onClick={handleShowModal}
        title="查看命令手册"
      >
        ?
      </Button>
      
      <CommandManualModal
        show={showModal}
        onHide={handleHideModal}
      />
    </>
  );
}; 